"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RETURN_ITEM_REDIRECT_PREFIX = exports.ACCOUNT_PROFILE_PAGE_LINK_EDIT_FORM_QUERY = void 0;
exports.ACCOUNT_PROFILE_PAGE_LINK_EDIT_FORM_QUERY = '?profileEdit=true';
exports.RETURN_ITEM_REDIRECT_PREFIX = 'return-item-';
